import { useEffect, useState, useRef } from "react";
import { useIsMobile } from "./hooks/useIsMobile";

const useDynamicPageSize = (
  tableHeaderId = "table-header",
  paginationId = "pagination-bar",
  footerId = "footer"
) => {
  const [pageSize, setPageSize] = useState(10);
  const resizeTimeoutRef = useRef<NodeJS.Timeout | null>(null);
  const isMobile = useIsMobile(991);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 992);
  useEffect(() => {
    const handleResize = () => setIsMobileView(window.innerWidth < 992);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  useEffect(() => {
    const calculatePageSize = () => {
      requestAnimationFrame(() => {
        const header = document.getElementById(tableHeaderId);
        const pagination = document.getElementById(paginationId);
        const footer = document.getElementById(footerId);
        const headerHeight = header?.offsetHeight || 0;
        const paginationHeight = pagination?.offsetHeight || 0;
        const footerHeight = footer?.offsetHeight || 0;
        let reservedSpace = 0;
        if (isMobileView) {
          const isAttendanceView = window.location.pathname.startsWith("/employees");
          const isAttendanceView1 = window.location.pathname.startsWith("/attendance-view");
          const payroll = window.location.pathname.startsWith("/payroll");
          const monthlySalary = window.location.pathname.startsWith("/monthlySalary")
          const resumes = window.location.pathname.startsWith("/resumes");
          if (isAttendanceView || isAttendanceView1 || monthlySalary) {
            reservedSpace = 340 + paginationHeight + footerHeight - 50;
          }else if (payroll || monthlySalary) {
            reservedSpace = 355 + paginationHeight + footerHeight;
          } else {
              reservedSpace = 300 + paginationHeight + footerHeight - 50 - 65;
          }
        } else {
          const isAttendanceView = window.location.pathname.startsWith("/employees");
          const isAttendanceView1 = window.location.pathname.startsWith("/attendance-view");
          const payroll = window.location.pathname.startsWith("/payroll");
          const monthlySalary = window.location.pathname.startsWith("/monthlySalary");
          const resumes = window.location.pathname.startsWith("/resumes");

          if (isAttendanceView || isAttendanceView1 || payroll || monthlySalary) {
            reservedSpace = 315 + paginationHeight + footerHeight - 50;
          } else  if (isAttendanceView) {
            reservedSpace = 315 + paginationHeight + footerHeight - 50;
          } else {
            reservedSpace = 190 + paginationHeight + footerHeight - 50;
          }
        }
       const availableHeight = window.innerHeight - reservedSpace;
        // Check if URL starts with /attendance-view
        const isEmployeeView = window.location.pathname.startsWith("/employees");
        const isAttendanceView = window.location.pathname.startsWith("/attendance-view");
        const isLeaveView = window.location.pathname.startsWith("/leave/leave-request");
        const isLeaveBalanceView = window.location.pathname.startsWith("/leave/leave-balance");
        const isInventoryView = window.location.pathname.startsWith("/inventory");
        const isPayHeaderView = window.location.pathname.startsWith("/pay-header");
        const isNotifications = window.location.pathname.startsWith("/all-notifications")
        const isResumes = window.location.pathname.startsWith("/resumes");
        const isBanners = window.location.pathname.startsWith("/banners");
        const isInterviews = window.location.pathname.startsWith("/interviews");
        const rowHeight = (isEmployeeView || isAttendanceView || isLeaveView || isInventoryView || isNotifications || isResumes || isInterviews || isBanners ) ? 42 : 30;
        const calculatedPageSize = Math.floor(availableHeight / rowHeight);
        const isVendors = window.location.pathname.startsWith("/vendors");
        const payroll = window.location.pathname.startsWith("/payroll");
        const monthlySalary = window.location.pathname.startsWith("/monthlySalary");
      

        if (!isLeaveView && !isNotifications && !isInventoryView && !payroll && !monthlySalary && !isEmployeeView && !isLeaveBalanceView && !isResumes && !isInterviews) {
        setPageSize(calculatedPageSize);
        } else if (monthlySalary) {
          if (isMobileView) {
            // mobile-specific corrections
            if (window.innerHeight <= 613) {
              setPageSize(calculatedPageSize - 3);
            } else if (window.innerHeight <= 680) {
              setPageSize(calculatedPageSize -6);
            } else if (window.innerHeight <= 718) {
              setPageSize(calculatedPageSize -3);
            } else if (window.innerHeight <= 768) {
              setPageSize(calculatedPageSize -6);
            } else if (window.innerHeight <= 932) {
              setPageSize(calculatedPageSize -7);
            } else {
              setPageSize(calculatedPageSize -10 );
            }
          } else {
            setPageSize(calculatedPageSize - 6);
          }
        }else if (payroll) {
          if (isMobileView) {
            // mobile-specific corrections
            if (window.innerHeight <= 613) {
              setPageSize(calculatedPageSize );
            } else if (window.innerHeight <= 680) {
              setPageSize(calculatedPageSize -3);
            } else if (window.innerHeight <= 718) {
              setPageSize(calculatedPageSize -3);
            } else {
              setPageSize(calculatedPageSize -6 );
            }
          } else {
            setPageSize(calculatedPageSize - 6);
          }
        }else if(isLeaveView && isMobile){
          setPageSize(calculatedPageSize - 2);
        } else if (isInventoryView && !isMobile){
        setPageSize(calculatedPageSize - 1);
        }else if (isBanners){
        setPageSize(calculatedPageSize );
        }else if (isEmployeeView){
          setPageSize(calculatedPageSize);
        } else if (isResumes){
          setPageSize(calculatedPageSize - 2);
        }else if (isInterviews){
          setPageSize(calculatedPageSize - 1);
        }else if (isInventoryView && isMobile  ){
        setPageSize(calculatedPageSize);
        } else if(isLeaveView && !isMobile){
          setPageSize(calculatedPageSize - 1);
        } else if(isLeaveBalanceView && !isMobile){
          setPageSize(calculatedPageSize+4);
        } else if(isLeaveBalanceView && isMobile){
          setPageSize(calculatedPageSize+2);
        } else if((isNotifications) && window.innerWidth < 912){
          setPageSize(calculatedPageSize + 1);
        } else if((isNotifications) && (window.innerWidth === 1024 && window.innerHeight === 1366)){
          setPageSize(calculatedPageSize - 1);
        } else if((isNotifications)){
          setPageSize(calculatedPageSize);
        } 

        if(isLeaveView){
          calculatePageSize()
        }
        if(isLeaveBalanceView){
          calculatePageSize()
        }
        console.log("ISMOBILE:",isMobile)
        console.log("header:", headerHeight, "pagination:", paginationHeight, "footer:", footerHeight, "calculated:", calculatedPageSize);
      });
    };
    const handleResize = () => {
      if (resizeTimeoutRef.current) clearTimeout(resizeTimeoutRef.current);
      resizeTimeoutRef.current = setTimeout(() => {
        calculatePageSize();
      }, 100);
    };
    calculatePageSize(); // Initial calculation
    
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
      if (resizeTimeoutRef.current) clearTimeout(resizeTimeoutRef.current);
    };
  }, [tableHeaderId, paginationId, footerId, isMobileView,isMobile]);
  return pageSize;
};
export default useDynamicPageSize;